import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    classLists: {},
    subjectLists: {},
    memberLists: {},
    documentLists: {},
    events: [],
    getParamListSchool: { "keyword": "", "pageIndex": 1, "pageSize": 0, "sort": "", "direction": "" },
    getCourseDetail: {},
    getClassListMember: {},
    getListLesonPlan: [],
    getParamDoccument: { "keyword": "", "pageIndex": 1, "pageSize": 10, "sort": "", "direction": "" },
    getListClassDoccument: {},
    getListEvent: {},
    getDetailEvent: {},
    getListClassPostion: [],
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};